import styled from 'styled-components';

import { theme } from '../../../../global-styles/colors';

export const AssistanceCardStyles = styled.article`
  padding: 16px;
  border-radius: 16px;
  background: ${theme.neutrals.white};
  box-shadow: 0 2px 12px rgba(29, 30, 32, 0.12);

  .assistance-card__header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
  }
  .assistance-card__icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    svg {
      font-size: 32px;
    }
  }
  .assistance-card__main {
    flex: 1;
    min-width: 0;
    p {
      overflow-wrap: anywhere;
    }
  }
  .assistance-card__file,
  .assistance-card__date {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
    svg {
      font-size: 20px;
      flex-shrink: 0;
    }
  }
  .assistance-card__file {
    color: ${theme.type.secondary};
  }
  .assistance-card__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 0px;
  }
  .assistance-card__location {
    flex: 1;
    min-width: 0;
    margin-top: 0;
    overflow-wrap: anywhere;
    font-size: 14px;
  }
  .assistance-card__status {
    flex-shrink: 0;
    padding: 4px 12px;
    border-radius: 16px;
    white-space: nowrap;
  }
  .assistance-card__detail {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
    color: ${theme.type.primary};
    svg {
      font-size: 16px;
      flex-shrink: 0;
      color: ${theme.greys.grey050};
    }
  }
  .survey-card__button {
    margin-top: 16px;
    button {
      background: ${(props) => props.theme.primary.primary10};
      color: ${(props) => props.theme.primary.primary70};
      &:hover {
        background: ${(props) => props.theme.primary.primary20};
      }
    }
  }
`;
